/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

var badcontentarray = [
    {accountname: 'wm',
        role: 'pm',
        badcontent: [{
                regex: '\s*class\s*=\s*"?\s*([\w\s%#\/\.;:_-]*)\s*"?.*?',
                replacement: '<br/>'
            }, {
                regex: '<\s*p*\s*class\s*=\s*"?\s*([\w\s%#\/\.;:_-]*)\s*"?.*?>',
                replacement: '<br/>'
            }, {
                regex: '<\s*span*\s*class\s*=\s*"?\s*([\w\s%#\/\.;:_-]*)\s*"?.*?>',
                replacement: '<span>'
            }, {
                regex: '<\s*\/?\s*p\s*.*?>',
                replacement: '<br/>'
            }]
    }];

